import React from "react";
import '../Css/Loader.css';

const Loader = ({ showimg }) => {
  return (
    <>
      {showimg && (
        <div className="dimmer active">
          <div className="lds-hourglass"></div>
        </div>
      )}
    </>
  );
};

export default Loader;